// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_CS7-X","stock_box":"index_stock_box_Y0fle"};